import React, { useContext, useEffect } from 'react'
import { Link, useHistory, Redirect } from 'react-router-dom';
import UserContext from '../../contexts/UserContext'
import useLocalStorage from '../Hooks/useLocalStorage';

const HeaderAccount = () => {

    let history = useHistory();

    const userContext = useContext(UserContext);

    const [user, setUser] = useLocalStorage('user', { nom: '' });

    const { logout } = userContext;

    if (!user) {

        return <Redirect to="/" push={true} />
    }

    return (
        <header className="py-3 mb-3 border-bottom">
            <div className="container-fluid d-grid gap-3 align-items-center">

                <div className="d-flex align-items-center">
                    <form className="w-100 me-3">
                    </form>

                    <div className="flex-shrink-0 dropdown">
                        <a href="#" className="d-block link-dark text-decoration-none dropdown-toggle" id="dropdownUser2" data-bs-toggle="dropdown" aria-expanded="false">
                            <img src={user.photo} alt="mdo" className="rounded-circle" width="32" height="32" />
                        </a>
                        <ul className="dropdown-menu text-small shadow" aria-labelledby="dropdownUser2">
                            <li><Link className="dropdown-item" to={`/account/profil/`}>Profil </Link></li>
                            <li><a className="dropdown-item" href="#" onClick={(e) => logout(e)}>Sign out</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </header >
    )
}

export default HeaderAccount